import React from 'react';
import {
  Field,
  FieldInputProps,
  FieldMetaState,
  FieldRenderProps,
} from 'react-final-form';

import AppStorage from 'Storage/Storage';
import { isProductWithMandatorySSN, translate } from 'utils/utils';
import Labels from '../../enums/Labels';
import { TafSsnInput } from '@taf-ui/react';

const defaultProps = {
  placeholder: '',
  label: '',
  isRequired: false,
};
type DefaultProps = Readonly<typeof defaultProps>;

export type Props = {
  label: Labels;
  placeholder: Labels;
  isRequired: boolean;
  meta: FieldMetaState<string>;
  input: FieldInputProps<string>;
  oldPattern?: boolean;
  locale?: string;
} & Partial<DefaultProps>;

export class SSNFormatInput extends React.PureComponent<Props> {
  private readonly storage: AppStorage;

  static defaultProps: DefaultProps = defaultProps;

  constructor(props: Props) {
    super(props);
    this.storage = AppStorage.getInstance();
  }

  isSSNMandatory() {
    return isProductWithMandatorySSN(this.storage.getProductType()) && this.storage.isDeductPremiumFromTaxes();
  }

  render(): React.ReactElement {
    const {
      input,
      meta,
      label,
      locale,
      oldPattern,
    } = this.props;

    const lang = this.storage.getLocale;

    return (
      <TafSsnInput
        label={translate(label, lang)}
        required={this.isSSNMandatory()}
        value={input.value}
        name={input.name}
        inputId={input.name}
        onTafChange={(e) => input.onChange(e.detail.value)}
        onTafBlur={() => input.onBlur()}
        validationState={meta.error && meta.touched ? 'error' : undefined}
        validationMessage={translate(meta.error as Labels, lang)}
        locale={locale}
        oldPattern={oldPattern}
      ></TafSsnInput>
    );
  }
}

const InputSSN = (): React.ReactElement => (
  <Field name="socialSecurityNumber">
    {({ input, meta }: FieldRenderProps<string>): React.ReactElement => (
      <SSNFormatInput
        label={Labels.PERSONAL_DETAILS_SSN}
        meta={meta}
        input={input}
      />
    )}
  </Field>
);

export default InputSSN;
